import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnalyticsModule, CdTableModule } from '@lbmx/analytics';
import { PerFormPrimengModule } from '@lbmx/per-form-primeng';
import { TranslocoModule } from '@ngneat/transloco';
import { DynamicDialogModule, ProgressSpinnerModule } from 'primeng-lts';
import { DashboardLoaderComponent } from './dashboard-loader/dashboard-loader.component';
import { DashboardTemplateComponent } from './dashboard-template/dashboard-template.component';
import { PurchasesBySupplierReportComponent } from './purchases-by-supplier-report/purchases-by-supplier-report.component';
import { ReportLoaderComponent } from './report-loader/report-loader.component';
import { ReportsComponent } from './reports/reports.component';
import { WidgetSelectionComponent } from './widget-selection/widget-selection.component';

@NgModule({
  declarations: [
    DashboardLoaderComponent,
    DashboardTemplateComponent,
    PurchasesBySupplierReportComponent,
    ReportLoaderComponent,
    ReportsComponent,
    WidgetSelectionComponent,
  ],
  imports: [
    AnalyticsModule,
    CdTableModule,
    CommonModule,
    DynamicDialogModule,
    PerFormPrimengModule,
    ProgressSpinnerModule,
    TranslocoModule,
  ],
  entryComponents: [WidgetSelectionComponent],
})
export class MarketplaceAnalyticsModule {}
